<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="white",
      absolute,
      top
    )
    v-dialog(
      v-model="dialogDraft",
      width="500"
     )
      v-card.pa-10
        v-row.justify-end
          v-icon(@click="dialogDraft=false") mdi-close
        v-text-field(
          :label="$t('Common.draftName')",
          v-model="draftName"
        )
        v-row.justify-center.pb-7
          v-btn(color="primary", @click="saveAsDraft", :disabled="loading") {{ $t("Common.saveAsDraft") }}
        v-row.justify-center.align-center
          v-icon(color="error") mdi-alert
          h4 {{ $t('Common.warningDraftFiles') }}
    v-dialog(
      v-model="dialogWarningFiles",
      persistent
      width="500"
     )
      v-card.pa-10
        v-row.justify-center.align-center
          v-icon(color="error") mdi-alert
          h4 {{$t('Common.warningOrderFiles')}}
        v-row.justify-center.pb-7.pt-7
          v-btn(color="primary", @click="redirectAfterSave", :disabled="loading") {{$t('Common.ok')}}

    v-row(v-show="!loading")
      v-col.py-0
        app-entity-stepper(v-if="!loading", @redirectToIndex="redirectToIndex", :disableSubmit="!hasSubmitPermission || blockEdit", :hasDraftPermission="hasDraftPermission", @saveAsDraft="dialogDraft = true", @submit="save()", :isEditing="isEditing", :entity="fullEntity", :ignoreTabs="orderIgnoreTabs", v-bind="{ customLabel, tabsWithErrors }")
          template(v-slot:Order="props")
            order-general(:slotProps="props", v-bind="{ errors, loading, uid }")
          template(v-slot:procurement="props")
            procurement(:slotProps="props", v-bind="{ errors }")
          template(v-slot:files="{ isActive }")
            document-request(:localFiles="filesToUpload", :localForm="filesFormData", :entity="entity", :parentInstance="instance", @sendFiles="handleFiles", :isActive="isActive")
          template(v-slot:comments="props")
            order-comments(:orderId="instance && instance.id", :orderBusinessScopeId="instance.businessScopeId", @update:comments="updateComments")
          template(v-slot:responsibilities="props")
            template(v-if="loading")
              v-skeleton-loader(
                class="mx-auto my-3"
                type="article"
              )
            template(v-else)
              app-entity-relation(v-bind="props")
          template(v-slot:orderLines="props")
            order-order-lines(:slotProps="props", v-bind="{ errors }")
          template(v-slot:summary="props")
            summary-order(:entity="entity", :parentInstance="instance")
</template>

<style>
  .relative-btn .add-entity-button {
    position: relative !important;
  }
</style>
<script>
import axios from 'axios'
import EntityMixin from '@/mixins'
import DraftMixin from '@/mixins/DraftMixin'
import OrderGeneral from '@/components/Order/General';
import Procurement from '@/components/Order/Procurement';
import OrderComments from '@/components/Order/Comments';
import OrderOrderLines from '@/components/Order/OrderLines';

export default {
  mixins: [EntityMixin, DraftMixin],
  name: 'order-add',
  components: {
    OrderGeneral,
    Procurement,
    OrderComments,
    OrderOrderLines,
  },
  data: function () {
    return {
      dialogDraft: false,
      dialogWarningFiles: false,
      draftName: null,
      loading: true,
      general: {},
      errors: {},
      documentErrors : false,
      filesToUpload: [],
      filesFormData: null,

      permIgnore: ['businessScope', 'OrderType', 'OrderComments', 'orderContacts', 'partyFrom', 'partyTo'],
      onAddIgnore: ['comments', 'responsibilities'],

      customAdditionalTabs: [
        { name: "procurement" , type: "procurement", fields:[]},
      ],

      menu2: false,
      date: null,
      loads: [
        'OrderContacts.Contact',
        'ExtraData',
        'BusinessScope',
        'User',
        'Comments',
        'PartyFrom.ExtraData',
        'PartyTo.ExtraData',
        'Status',
        'Files',
        'OrderLines.CollectionPoint.ExtraData',
        'OrderLines.DeliveryPoint.ExtraData',
        'OrderLines.OrderLineContacts.Contact',
        'OrderLines.ExtraData',
        'OrderLines.Status',
        'OrderLines.Product',
      ],

      blockEdit: false,
      tabsWithErrors: [],
      tabsOrder: ['orderLines'], // order for the first tabs
      endTabs: ['files','responsibilities', 'comments', 'history'], // go after extra data according to design
    }
  },
  watch: {},
  computed: {
    hasSubmitPermission() {
      if (this.uid)
        return this.$store.state.schema.all.find(e => e.name == this.entityName).actions.edit;
      return this.$store.state.schema.all.find(e => e.name == this.entityName).actions.create;
    },
    portal() {
      return this.$route.params.portal
  },
    customLabel() {
      return ({
        partyFrom: this.$t('Order.partyFrom'),
        partyTo: this.$t('Shipment.partyTo'),
        Order: this.$t('Order.general'),
        procurement: this.$t('Order.procurement'),
        files: this.$tc('DocumentRequest._name', 1),
        responsibilities: this.$t('Order.responsibilities'),
        orderLines: this.$t('Order.orderLines'),
        history: this.$t('Order.history'),
        summary: this.$t('Order.summary'),
        comments: this.$t('Order.comments'),
      });
    },
    fullEntity() {
      let entity = {...this.entity};
      let allFields = [...this.customAdditionalTabs, ...this.entity.fields];
      // get all non last tabs
      let fields = _(allFields).sortBy((obj) => _.indexOf(this.tabsOrder, obj.name))
        .filter(f => !this.endTabs.includes(f.name));
      // get last tabs and order according to the endtabs data field
      let endTabs = _(allFields).filter(f => this.endTabs.includes(f.name))
        .sortBy((f) => _.indexOf(this.endTabs, f.name)).value();
      // set extras to the end
      entity.fields = fields.value().sort((f1, f2) => {
        if (f1.extra && f2.extra) return 0;
          if (f1.extra && !f2.extra) return 1;
          if (!f1.extra && f2.extra) return -1;
          return 0;
      });
      // append endtabs
      entity.fields.push(...endTabs);
      return entity;
    },
    hasDraftPermission() {
      return this.$store.state.schema.all.find(e => e.name == 'Draft').actions.create;
    },
    entityName () {
      return 'Order'
    },
    entity () {
      return this.$findEntity('Order')
    },
    uid () {
      return this.$route.params.item
    },
    orderIgnoreTabs() {
      return [...this.permIgnore, ...(this.uid ? [] : this.onAddIgnore), 'shipFromParty', 'shipToParty'];
    },
    partyFromId() {
      return this.instance && this.instance.partyFrom && this.instance.partyFrom.id
    },
    partyToId() {
      return this.instance && this.instance.partyTo && this.instance.partyTo.id
    },
    isEditing() {
      return this.instance && this.instance.entityState == 3;
    },
  },
  methods: {
    handleFiles(val) {
      const fd = new FormData()

      val.map(f => {
        fd.append('files', f.file)
        fd.append('types', f.fileType)
        fd.append('documentRequestIds', f.documentRequestId)
      })
      fd.append('entity', 'Order')
      this.filesToUpload = val
      this.filesFormData = fd
    },

    mapErrors(errors = {}) {
      this.tabsWithErrors = [];
      const rootFields = ['receiverReference', 'shipperReference'];
      const procurementFields = ['timeZone', 'specificPickupTime', 'specificDeliveryTime', 'datePickupFrom', 'datePickupTo', 'dateDeliveryFrom', 'dateDeliveryTo'];
      const orderLinesFields = ['orderLines'];
      const documentRequestFields = ['packages'];

      if (_.keys(errors).some(r=> _.some(rootFields, v => r.includes(v)))) this.tabsWithErrors.push('Order');
      if (_.keys(errors).some(r=> _.some(procurementFields, v => r.includes(v)))) this.tabsWithErrors.push('procurement');
      if (_.keys(errors).some(r=> _.some(orderLinesFields, v => r.includes(v)))) this.tabsWithErrors.push('orderLines');
      if (_.keys(errors).some(r=> _.some(documentRequestFields, v => r.includes(v)))) this.tabsWithErrors.push('documentRequest');
    },

    /* TODO: docs */
    async save () {
      try{
        this.loading = true
        if (this.instance.businessScope == null || this.instance.businessScopeId === null) this.instance.businessScopeId = this.$getBusinessScopeId()

        // map collection point and delivery points ids instead of using objects
        if (this.instance.orderLines != null && this.instance.orderLines.length > 0) {
          this.instance.orderLines.map(ol => {
            // TODO move this logic to orderline component (set ids on collection/delivery points)
            if (ol.collectionPoint != null)  { ol.collectionPointId = ol.collectionPoint.id; ol.collectionPoint = null;}
            if (ol.deliveryPoint != null) { ol.deliveryPointId = ol.deliveryPoint.id; ol.deliveryPoint = null; }
            if (ol.entityState === 0) { ol.entityState = 3 }
            return ol;
          });
        }

        //Set documentsRequestsToUpload in order to validate Files
        this.instance.documentsRequestsToUpload = this.filesToUpload.map(f => ({DocumentRequestId: f.documentRequestId,FileName: f.file.name}))
        this.instance = (await axios.post('entity/graph', this.instance)).data
        if (this.isDraft) {
          const deletedDraft = { ...this.draft, entityState: 2 };
          await axios.post('entity/graph', deletedDraft);
        }
        try {
          if(this.filesFormData != null && this.filesFormData.has('files')){
            await axios.post(`file/media/${this.instance.id}`, this.filesFormData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
          }
          this.redirectAfterSave();
        } catch (error) {
          if (this.instance.id && error.response != null && error.response.config.url.includes("file/media")) {
            this.dialogWarningFiles = true;
            //this.redirectAfterSave();
            // this.instance.entityState = 3;
          }
        }
      } catch (error) {
        const requestErrors = _.get(error, 'response.data.errors');
        if (requestErrors) {
          this.errors = error.response.data.errors;
          this.mapErrors(requestErrors);
        }
        console.log(`[Order][save] error`, this.$cleanString(error))
      } finally {
        this.loading = false
      }
    },

    redirectAfterSave()
    {
      if (_.get(this.$route, 'query.workstation')) {
        this.$router.push({
          name: 'home',
        });
      } else {
        let routeName = this.portal ? 'order.portal' : 'order.index';
        this.$router.push({
          name: routeName,
          params: { portal: this.portal },
        });
      }
    },

    /**
    Get Business Scope according to the businessScopeId given
    */
    async getBusinessScope(businessScopeId){
      if(businessScopeId == null) return null;
      let bs = (await axios.get('BusinessScope?where[]=id=' + businessScopeId)).data.data;
      return bs[0];
    },

     /**
     * Load the entity with the next relations:
     * ExtraData, BusinessScope, User, Comments, OrderLines.Process, OrderLines.ExtraData, OrderLines,
     * OrderLines.Responsibilities.User, OrderLines.Responsibilities.Process, OrderLines.Responsibilities.Task,
     * OrderLines.Responsibilities.
     * Format the dates in to [DD-MMM-YYYY hh:mm a] format and load the time zone
     */
    async load () {
      //Get the statuses and handling units lists
      // If the page is editing a draft, loads it and populate the draft info.
      if((await this.loadDraft())) {
        this.permIgnore.push('history', 'comments', 'Responsibilities');
        return;
      }

      if (this.uid) {
        try {
          const endpoint = this.$fetchLoad(`${this.entity.name}/${this.uid}`, true, ...this.loads)
          let _instance = (await axios.get(endpoint, {
            _Entity: this.entity.name,
            uid: this.uid
          })).data;

          _instance = {
            partyFrom: {contactParties:[]},
            partyTo: {contactParties:[]},
            ..._instance,
            entityState: 3
          };
          this.instance = _instance;
          const { status } = this.instance;
          ({ blockEdit: this.blockEdit } = status || {});
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      } else {
        this.instance = {
          partyFrom: {contactParties:[]},
          partyTo: {contactParties:[]},
          orderContacts: [],
          ...this.instance
        }
        this.loading = false;
      }
    },
    redirectToIndex() {
      let routeName = 'order.index';
      this.$router.push({
        name: routeName
      });
    },
    updateComments(comments) {
      this.instance.comments = comments;
    },
  },
  async created() {
    const lsbusinessScopeId = window.localStorage.getItem("BusinessScopeId");
    const lsbusinessScope = await this.getBusinessScope(lsbusinessScopeId);

    this.$store.commit('SET_INSTANCE', { entityState: 4,
                                        _Entity: this.entity.name,
                                        user: this.$store.state.user.user,
                                        businessScopeId: lsbusinessScopeId,
                                        businessScope: lsbusinessScope
                                        })
    await this.load()
  },
}
</script>
